import { render, staticRenderFns } from "./global-filter.vue?vue&type=template&id=2195afe0&scoped=true&"
import script from "./global-filter.vue?vue&type=script&lang=js&"
export * from "./global-filter.vue?vue&type=script&lang=js&"
import style0 from "./global-filter.vue?vue&type=style&index=0&id=2195afe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195afe0",
  null
  
)

export default component.exports